import { Box, Text } from '@chakra-ui/react'

export function PromptResultBox({ text }: { text: string }) {
  return (
    <Box bg="lightgray" borderRadius="md" p="6">
      <Text>{text}</Text>
    </Box>
  )
}
